var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTopPnL(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.332 39H25.332V43H39.332V39Z",
    fill: "#FBEDAF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.332 59V63H17.332V59H19.332H45.332H47.332Z",
    fill: "#CA8600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.332 43L45.332 59H19.332L20.332 43H25.332H39.332H44.332Z",
    fill: "#CA8600"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.332 47L41.332 55H23.332L24.332 47H40.332Z",
    fill: "#F6DF6D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.332 50H26.332V52H28.332V50Z",
    fill: "#9196AA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.332 50H30.332V52H38.332V50Z",
    fill: "#9196AA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.457 57L19.332 59H45.332L45.207 57H19.457Z",
    fill: "#AF7401"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.332 32H27.332V39H37.332V32Z",
    fill: "#FFFDF4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.332 28V32H37.332H27.332H20.332V28H44.332Z",
    fill: "#FBEDAF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1836 24H46.4836C46.3836 25.33 46.3336 26.66 46.3336 28H18.3336C18.3336 26.66 18.2836 25.33 18.1836 24Z",
    fill: "#E9B44B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3322 1L27.1022 3.86C26.2249 4.62304 25.5231 5.56687 25.0449 6.62672C24.5668 7.68656 24.3236 8.83732 24.3322 10C22.6273 8.02436 20.6628 6.2886 18.4922 4.84L22.3322 1Z",
    fill: "#EAB44B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3308 1L46.7708 4.44C44.367 5.97282 42.1979 7.84558 40.3308 10C40.3404 8.89207 40.1205 7.79415 39.6851 6.77532C39.2497 5.75649 38.6081 4.8388 37.8008 4.08L38.3308 4L43.3308 1Z",
    fill: "#EAB44B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M46.772 4.44C48.221 3.50042 49.7464 2.68422 51.332 2C48.7666 9.09153 47.1362 16.4871 46.482 24H18.182C17.5278 16.4871 15.8974 9.09153 13.332 2C15.139 2.77926 16.8669 3.73029 18.492 4.84C20.6626 6.2886 22.6271 8.02436 24.332 10C24.3235 8.83732 24.5666 7.68656 25.0448 6.62672C25.5229 5.56687 26.2247 4.62304 27.102 3.86C28.61 2.52816 30.397 1.55091 32.332 1C34.3732 1.57988 36.2478 2.63541 37.802 4.08C38.6094 4.8388 39.251 5.75649 39.6864 6.77532C40.1218 7.79415 40.3416 8.89207 40.332 10C42.1991 7.84558 44.3683 5.97282 46.772 4.44Z",
    fill: "#FFE870"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18.492 9.84C20.2827 11.0563 21.9428 12.4544 23.446 14.012C23.7739 14.0299 24.0922 14.1292 24.372 14.301C24.5373 12.2006 25.517 10.248 27.102 8.86C28.61 7.52816 30.397 6.55091 32.332 6C34.3732 6.57988 36.2478 7.63541 37.802 9.08C39.2521 10.4503 40.1407 12.3109 40.295 14.3C40.5746 14.1285 40.8925 14.0291 41.22 14.011C42.8918 12.2822 44.7544 10.7487 46.772 9.44C47.584 8.915 48.478 8.398 49.431 7.906C50.452 4.289 51.332 2 51.332 2C49.7464 2.68422 48.221 3.50042 46.772 4.44C44.3683 5.97282 42.1991 7.84558 40.332 10C40.3416 8.89207 40.1218 7.79415 39.6864 6.77532C39.251 5.75649 38.6094 4.8388 37.802 4.08C36.2478 2.63541 34.3732 1.57988 32.332 1C30.397 1.55091 28.61 2.52816 27.102 3.86C26.2247 4.62304 25.5229 5.56687 25.0448 6.62672C24.5666 7.68656 24.3235 8.83732 24.332 10C22.6271 8.02436 20.6626 6.2886 18.492 4.84C16.8669 3.73029 15.139 2.77926 13.332 2C13.332 2 14.212 4.289 15.232 7.907C16.3564 8.48559 17.445 9.13108 18.492 9.84Z",
    fill: "#FFF2B0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7966 6.64899C49.6786 7.04899 49.5576 7.46199 49.4336 7.89999C49.5576 7.46199 49.6786 7.04599 49.7966 6.64899Z",
    fill: "#FFAC5A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1726 2.427C51.1286 2.548 51.0726 2.696 51.0156 2.866C51.0756 2.7 51.1306 2.547 51.1726 2.427Z",
    fill: "#FFAC5A"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M50.463 4.5C50.369 4.787 50.271 5.094 50.168 5.425C50.2706 5.09633 50.369 4.788 50.463 4.5Z",
    fill: "#FFAC5A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1445 5.509C50.0375 5.852 49.9275 6.214 49.8125 6.598C49.9265 6.214 50.0335 5.852 50.1445 5.509Z",
    fill: "#FFAC5A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2914 2.11099L51.1914 2.38499C51.2334 2.26999 51.2684 2.17399 51.2914 2.11099Z",
    fill: "#FFAC5A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M28.332 50H26.332V52H28.332V50Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M38.332 50H30.332V52H38.332V50Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopPnL);
export default __webpack_public_path__ + "static/media/topPnL.04483442c235608242c185521f04959b.svg";
export { ForwardRef as ReactComponent };